import a from "./ghl-ui.es1208.js";
import g from "./ghl-ui.es1209.js";
import h from "./ghl-ui.es641.js";
import b from "./ghl-ui.es676.js";
import A from "./ghl-ui.es1210.js";
import c from "./ghl-ui.es1211.js";
var d = Object.prototype, O = d.hasOwnProperty;
function l(t, p) {
  var o = h(t), i = !o && g(t), s = !o && !i && b(t), e = !o && !i && !s && c(t), n = o || i || s || e, f = n ? a(t.length, String) : [], m = f.length;
  for (var r in t)
    (p || O.call(t, r)) && !(n && // Safari 9 has enumerable `arguments.length` in strict mode.
    (r == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (r == "offset" || r == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    e && (r == "buffer" || r == "byteLength" || r == "byteOffset") || // Skip index properties.
    A(r, m))) && f.push(r);
  return f;
}
export {
  l as default
};
